import PropTypes from "prop-types";

const SVGProps = {
  size: PropTypes.number,
  fillColor: PropTypes.string,
  strokeColor: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export default SVGProps
